import { z } from 'zod';

import { flexiblePhoneNumberRegex } from '~/utils/validationRegex';

export const PhoneNumberSchema = z
  .string({
    error: (issue) =>
      issue.input === undefined ? 'Phone number is required' : 'Phone number must be a string',
  })
  .max(20, {
    error: 'Phone number must contain at most 20 characters',
  })
  .refine((val) => val == null || flexiblePhoneNumberRegex.test(val), {
    error: 'Phone number is invalid',
  });

export const PhoneNumberRequiredSchema = z
  .string()
  .trim()
  .superRefine((val, ctx) => {
    const onlyDigits = val.replace(/\D/g, '');
    if (onlyDigits.length != 10) {
      ctx.addIssue({
        code: 'custom',
        message: 'Must be 10 numeric digits',
      });
    }
  });

export const RawPhoneNumberSchema = z
  .string()
  .trim()
  .min(10, { error: 'Must be at least 10 characters' })
  .max(20, { error: 'Cannot be longer than 20 characters' })
  .regex(flexiblePhoneNumberRegex, {
    error: 'Must contain digits and formatting characters only (, ), -',
  })
  .or(z.literal(''))
  .nullable()
  .optional();
